(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.options = {
        type: 'fade',
        autoplay: true,
        interval: 5000,
        rewind: true,
        rewindByDrag: true,
        waitForTransition: false,
        perPage: 1,
        arrows: false,
        pagination: false
      };

      if (this.autoplay) {
        this.options.autoplay = this.autoplay;
        this.options.interval = this.autoplaySpeed;
      }
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
